const supportFaq = [
  {
    id: 'analysis-types',
    category: 'Platform',
    question: 'What types of analyses does Quantum Husky support?',
    answer:
      'We currently support equity (stock) analyses, including short-term, fundamental, social sentiment, and news-driven assessments. Additional asset classes such as crypto, ETFs, and options will be added soon.',
    links: [],
  },
  {
    id: 'analysis-depth',
    category: 'Platform',
    question: 'How do I upgrade or downgrade my analysis depth (Shallow / Medium / Deep / Maximum)?',
    answer:
      'When creating a new analysis, the Platform will let you choose your desired research depth. Each level includes more analyst types and longer reasoning sequences. Pricing adjusts automatically based on the selected depth.',
    links: [
      { label: 'Launch New Analysis', url: '/tasks/new' },
    ],
  },
  {
    id: 'subscription-overview',
    category: 'Subscriptions',
    question: 'What is a scheduled-analysis subscription?',
    answer:
      'A scheduled-analysis subscription creates a recurring analysis for one US equity ticker. The current plan runs on a fixed daily schedule, bills monthly through Stripe, and can send an email when that subscription\'s shared decision changes.',
    keywords: ['what is subscription', 'what is a subscription', 'subscription meaning'],
    links: [
      { label: 'View Scheduled Tasks', url: '/scheduled-tasks' },
    ],
  },
  {
    id: 'subscription-setup',
    category: 'Subscriptions',
    question: 'How do I start a recurring analysis subscription?',
    answer:
      'Go to Scheduled Tasks, choose New Scheduled Analysis, configure the ticker, research depth, and analysts, then complete the Stripe payment step. The current subscription plan runs on a fixed daily schedule after payment confirmation.',
    keywords: ['start subscription', 'create subscription', 'scheduled analysis subscription'],
    links: [
      { label: 'Create Scheduled Analysis', url: '/scheduled-tasks/new' },
    ],
  },
  {
    id: 'payment-failed',
    category: 'Billing',
    question: 'Why did my payment fail?',
    answer:
      'Payments may fail due to insufficient funds, bank restrictions, expired cards, or mismatched billing details. You can retry payment or update your card from the checkout screen. If the issue persists, contact support.',
    links: [],
  },
  {
    id: 'analysis-stuck',
    category: 'Platform',
    question: 'What happens if an analysis gets stuck or takes too long?',
    answer:
      'If an analysis exceeds the normal processing window, it is automatically flagged. You will either receive a completed result once processing finishes, or receive a refund/credit if the system detects a failure.',
    links: [],
  },
  {
    id: 'cancel-analysis',
    category: 'Platform',
    question: 'Can I cancel an analysis after it starts?',
    answer:
      'Once the analysis computation begins, it cannot be canceled due to model and compute costs. If the task is still "Pending Payment," you may cancel it freely.',
    links: [],
  },
  {
    id: 'refunds',
    category: 'Billing',
    question: 'Do you offer refunds?',
    answer:
      'Refunds are available for duplicate charges, system errors, analyses that fail to complete, and paid scheduled-analysis executions that have not run yet. Completed one-time analyses remain final once delivered.',
    links: [],
  },
  {
    id: 'subscription-billing',
    category: 'Subscriptions',
    question: 'How does billing work for scheduled-analysis subscriptions?',
    answer:
      'Scheduled-analysis subscriptions are billed monthly through Stripe for the current daily subscription plan. The Scheduled Tasks page shows the current monthly cost, and Transactions records completed subscription charges.',
    keywords: ['subscription billing', 'monthly billing', 'subscription charge'],
    links: [
      { label: 'View Scheduled Tasks', url: '/scheduled-tasks' },
      { label: 'View Transactions', url: '/purchases' },
    ],
  },
  {
    id: 'subscription-cancel',
    category: 'Subscriptions',
    question: 'How do I cancel a subscription, and what refund do I receive?',
    answer:
      'Open Scheduled Tasks and unsubscribe the active subscription. Cancellation takes effect immediately, future runs stop, and the refund is based on paid executions that have not run yet.',
    keywords: ['cancel subscription', 'unsubscribe', 'subscription refund', 'unused execution refund'],
    links: [
      { label: 'Manage Scheduled Tasks', url: '/scheduled-tasks' },
    ],
  },
  {
    id: 'subscription-notifications',
    category: 'Subscriptions',
    question: 'Can I get email alerts for subscription analyses?',
    answer:
      'Yes. When creating a scheduled analysis, you can add a notification email address. The platform sends an email when that subscription\'s shared decision changes.',
    keywords: ['subscription email', 'subscription notification', 'decision change email'],
    links: [],
  },
  {
    id: 'change-email',
    category: 'Account & Login',
    question: 'How do I change my account email or profile details?',
    answer:
      'Go to Profile → Account Settings to update personal information. For email changes requiring verification, please contact support.',
    links: [
      { label: 'Go to Profile', url: '/profile' },
    ],
  },
  {
    id: 'history-private',
    category: 'Privacy',
    question: 'Is my analysis history private?',
    answer:
      'Yes. Your analysis history is visible only to your account. We do not sell or share analysis data with third parties.',
    links: [],
  },
  {
    id: 'download-reports',
    category: 'Platform',
    question: 'How do I download my reports?',
    answer:
      'Each completed task includes a "View Reports" button. Inside the report view, you can download the PDF/HTML version or copy the reasoning.',
    links: [
      { label: 'View History', url: '/tasks' },
    ],
  },
  {
    id: 'card-storage',
    category: 'Privacy',
    question: 'Do you store my credit card information?',
    answer:
      'No. All payments are processed securely through Stripe. Quantum Husky never stores or has access to your card number.',
    links: [],
  },
  {
    id: 'unauthorized-access',
    category: 'Account & Login',
    question: 'What should I do if I suspect unauthorized access?',
    answer:
      'Immediately reset your password using the Forgot Password link. Then contact support so we can review account activity.',
    links: [],
  },
  {
    id: 'billing-amounts',
    category: 'Billing',
    question: 'Why do some tasks have higher billing amounts?',
    answer:
      'Billing varies depending on: research depth, number of analyst personas, runtime length, and market data sources consumed. Deep and Maximum levels use more computers and more AI agents.',
    links: [],
  },
  {
    id: 'international',
    category: 'Platform',
    question: 'Can I use Quantum Husky outside the United States?',
    answer:
      'Yes. The platform is available globally wherever Stripe is supported. (Some regions may not have access to certain data sources.)',
    links: [],
  },
  {
    id: 'human-support',
    category: 'Support',
    question: 'How do I contact human support instead of AI?',
    answer:
      'You can reach us anytime at support@quantumhusky.ai. Human support typically responds within 12–24 hours.',
    links: [],
  },
]

export default supportFaq
